const Usertie = props => (
  <svg
    width="1em"
    height="1em"
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="user-helmet-safety"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M88 176h272c4.375 0 8-3.625 8-8V136c0-4.375-3.625-8-8-8H352c0-46.38-28.5-85.5-68.75-102.4L256 80V16c0-8.875-7.125-16-16-16h-32c-8.875 0-16 7.125-16 16V80L164.8 25.62C124.5 42.5 96 81.63 96 128H88c-4.375 0-8 3.625-8 8v31.1C80 172.4 83.63 176 88 176zM224 272c-38 0-70.75-26.75-78.38-64h-48C105.6 271 158.8 320 224 320s118.5-49 126.4-112h-48C294.8 245.3 261.1 272 224 272zM314.7 352H133.3C59.7 352 0 411.7 0 485.3c0 14.73 11.94 26.67 26.66 26.67H421.3c14.72 0 26.66-11.94 26.66-26.67C448 411.7 388.3 352 314.7 352zM50.7 464c9.498-36.76 42.95-64 82.64-64h181.3c39.69 0 73.14 27.24 82.64 64H50.7z"
    ></path>
  </svg>
)

export default Usertie
